import { render } from "./x-axis.vue?vue&type=template&id=2051dd36&ts=true&lang=pug"
import script from "./x-axis.vue?vue&type=script&setup=true&lang=ts"
export * from "./x-axis.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__